import { Component, OnInit, Input } from "@angular/core";
import { CTAButtonFeaturesLayout } from "../cta-button-features-layout";
import { CTAButtonFeaturesSimpleListLayoutContext } from "./features-simple-list-layout.model";

@Component({
    selector: "dodo-features-simple-list-layout",
    templateUrl: "./features-simple-list-layout.component.html",
    styleUrls: ["./features-simple-list-layout.component.scss"],
    standalone: false
})
export class FeaturesSimpleListLayoutComponent
	extends CTAButtonFeaturesLayout<CTAButtonFeaturesSimpleListLayoutContext>
	implements OnInit {
	@Input() showInfoIcon: boolean;
	@Input() title: string;
	@Input() features: string[];
	@Input() footnote: string[];

	set context(ctx: CTAButtonFeaturesSimpleListLayoutContext) {
		this.title = this.title || ctx.title;
		this.features = this.features || ctx.features;
		this.footnote = this.footnote || ctx.footnote;
		this.showInfoIcon = this.showInfoIcon || ctx.showInfoIcon;
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
